export default class Timezones {
	static TIME_TYPE_UTC = 0;
	static TIME_TYPE_LOCAL = 1;
	static TIME_TYPE_GAMEWORLD = 2;
}